module.exports = __webpack_public_path__ + "img/xyqh.6a9f8efb.jpg";